import React, {Component} from 'react'
import {Alert, Select, Spin} from "antd"
import PropTypes from "prop-types"
import {listUserCut} from "../../../services/api/3dApi"

const {Option} = Select

class FilterUserCut extends Component {
    state = {
        usersCut: this.props.usersCut,
        options: [],
        loading: false,
        error: ''
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({
                usersCut: this.props.usersCut
            })
        }
    }

    componentDidMount() {
        this._fetchListUserCut()
    }

    _handleChange = (value) => {
        const {onChangeUsersCut} = this.props

        if (typeof onChangeUsersCut === 'function') {
            onChangeUsersCut(value)
        }
    }

    _fetchListUserCut = async () => {
        this.setState({
            loading: true,
            error: ''
        })
        try {
            const {data: response} = await listUserCut()
            const {data, success} = response

            if (!success) {
                return this.setState({
                    loading: false,
                })
            }

            const newData = data.length > 0 && data.filter((item) => {
                return item
            })

            this.setState({
                loading: false,
                options: newData
            })

        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    render() {
        const {usersCut, options, loading, error} = this.state

        return (
            <div className="FilterProductType">
                {error ? <Alert message={error} type={'error'}/> :
                    <Spin spinning={loading}>
                        <Select
                            mode="multiple"
                            style={{width: '100%'}}
                            showArrow={true}
                            placeholder="Vui lòng chọn người cắt bạn muốn tìm kiếm"
                            defaultValue={usersCut}
                            onChange={this._handleChange}
                            value={usersCut}
                            allowClear
                        >
                            {
                                options.map((option, index) => {
                                    return <Option key={index} value={option}>{option}</Option>
                                })
                            }
                        </Select>
                    </Spin>
                }
            </div>
        )
    }
}

FilterUserCut.defaultProps = {
    loading: false
}

FilterUserCut.propTypes = {
    loading: PropTypes.bool,
    usersCut: PropTypes.array,
    onChangeUsersCut: PropTypes.func.isRequired
}

export default FilterUserCut
